import { useState, useEffect, useRef } from "react";
import { CaretDownOutlined } from "@ant-design/icons";
import CruiseSearchTabs from "./CruiseSearchTabs";

const CruiseMegaMenu = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      {/* Menu Trigger */}
      <div
        className="flex items-center cursor-pointer font-semibold text-gray-800 hover:text-blue-600 select-none"
        onClick={() => setOpen((prev) => !prev)}
      >
        Cruises
        <CaretDownOutlined
          className={`ml-1 text-xs transition-transform duration-200 ${
            open ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>

      {/* Dropdown Panel */}
      <div
        className={`absolute w-[70vw] left-0 top-12 bg-white shadow-xl  z-50 
          transition-all duration-300 ease-in-out ${
          open
            ? "opacity-100 visible translate-y-0"
            : "opacity-0 invisible -translate-y-2"
        }`}
      >
        <CruiseSearchTabs />
      </div>
    </div>
  );
};

export default CruiseMegaMenu;
